import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import ActivateVerify from "./components/verify";
import "./App.css";
import Receipt from "./components/receipt";
import WebReceipt from "./components/web-receipt/WebReceipt";
import AppReceipt from "./components/web-receipt/AppReceipt";
import PaymentPage from "./components/PaymentPage/PaymentPage";
import FlightAlerts from "./components/FlightAlerts/FlightAlerts";
import MyFlightAlerts from "./components/FlightAlerts/MyFlightAlerts";
import SharedLogin from "./components/SharedLogin/SharedLogin";
import HailingFlow from "./components/hailing/HailingFlow";

const App = () => {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route element={<Receipt />} path="/receipt/:id" />
          <Route element={<ActivateVerify />} path="/activation/:id" />
          <Route element={<WebReceipt />} path="/web-receipt/:id" />
          {/* App-shared trip tracking: same data as web-receipt, but hides the
              payment card and the cancel-trip button (DASH-5282). */}
          <Route element={<AppReceipt />} path="/app-receipt/:id" />
          {/* <Route element={<PaymentPage />} path="/payment-page/:id" /> */}
          {/* Placeholder path pending product's route decision — see plan
              Open Question 1 (DASH-6077). */}
          <Route element={<FlightAlerts />} path="/flight-alerts" />
          <Route element={<MyFlightAlerts />} path="/flight-alerts/list" />
          <Route element={<SharedLogin />} path="/shared-login" />
          {/* Web Hailing Flow */}
          <Route element={<HailingFlow />} path="/web-hailing" />
        </Routes>
      </Router>
    </div>
  );
};

export default App;

